const initialState = [
];

export default function statuses(state = initialState, action) {
    switch (action.type) {
        case 'SET_STATUSES':
            return action.value;
        default:
            return state;
    }
}
